import React, { useEffect } from "react";
import configData from "../config.json";
import {useNavigate}  from "react-router-dom";

import {getHeaderColNames,formatToTwoDecimalPlaces} from "../utils";



const UserDT = ({ tableData, firstColWidth = "60px", secColWidth = "210px", handleExportSheet = () => { console.log("Event not defined for export.") }, highlightedDataCells=[] , resetHandle=()=>{},changeUserStatus=()=>{}, isPermissionTable = false}) => {

 
  const navigate = useNavigate();


  useEffect(() => {
    document.body.classList.add('sidebar-folded');
    window.handleExportExcel = handleExportSheet;

    return () => {
    
      window.handleExportExcel = handleExportSheet;

    };

  }, []);

 
  

  const headers = Object.keys(tableData.data[0]).filter(key => key !== 'color');

  const tableRowColors = ['table_rowtransparent', 'table_rowcolored', 'table_rowseccolored', 'table_rowthirdcolor', 'table_rowfourthcolor'];

  const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };

  const alignData = (header, value) => {

    if (header === "code" || header === "pack" || header === "name") {
      return false;
    }
    return isNumeric(value);
  }

  const alignHeader = (header, index) => {

    if (header === "code" || header === "fname" || header === "name" || header == "login_name"
      || header == "time" || header == "entry_date" || header == "status" || header == "type"
      || header == "division" || header == "batch_no" || header == "expiry_date" || header == "last_login_date"
      || header == "status" || header == "branch" || header == "branch_name" || header == "billing_date" || header == "remark") {
      return false;
    } else {
      return true;
    }
  }

  const headerTitle = (headerParam) => {
    if (configData.col_newheader_names[headerParam]) {
      return configData.col_newheader_names[headerParam].toUpperCase();
    } else {
      return headerParam.toUpperCase().replace(/_/g, ' ');
    }


  }

  const handlePermission = () =>{
    navigate("/settings-user-permissions")
  }
  const highlightDataCell = ( key ) => {

    if(highlightedDataCells.length == 0){
      return "";
    }

    if(highlightedDataCells.includes(key)){
      return "highlightedDataCell";
    }

    return "";

  }
  const getColWidth = (index) => {
    if (index == 0) {
      return firstColWidth;
    } else if (index == 1) {
      return secColWidth;
    } else {
      return "auto";
    }
  }
  return (
    <div className="" >
      <table className=" table table-striped " data-fixedHeader="true" cellspacing="0" id="reportDataTable" data-dom='plftrip' data-provide="datatables"  >
        <thead>
          <tr>
            {headers.map((header, thindex) => (
              <th style={{ textAlign: alignHeader(header, thindex) ? 'right' : 'left', width: getColWidth(parseInt(thindex)) }} key={header}> {getHeaderColNames(header)}</th>
            ))}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {tableData.data.map((row, index) => (
            <tr  key={index} className={tableRowColors[row.color]}>
              {headers.map((header, tdindex) => (
                <td className={highlightDataCell(header)}  style={{ whiteSpace: 'pre-wrap', textAlign: alignData(header, row[header]) ? 'right' : 'left', width: getColWidth(parseInt(tdindex)) }} key={header}>
{header == "user_status" ? 
                  <>
                  {row[header] == "Y" ? <span class="badge badge-success">Enabled</span> : <span class="badge badge-danger">Disabled</span> }
                  </>
                  : 
                <>{row[header]}</> 
                } </td>
              ))}
              <td>
              
                 <a  className="btn btn-sm btn-outline btn-info  " href={`/settings-user-permissions/${row['login_id']}/${row['login_name']}/${row['utype']}`}>Permissions</a>
                &nbsp;
                 <button  className="btn btn-sm btn-outline btn-info   " onClick={()=>{resetHandle(row['login_id'])}}>Reset Password</button>
                 &nbsp;
                 {row['user_status'] == "Y" ?
                   <button className="btn btn-sm btn-outline btn-danger" onClick={()=>{ console.log(row['login_id']);changeUserStatus(row['login_id'], "N")}}>Disable</button> :
                    <button className="btn btn-sm btn-outline btn-success" onClick={()=>{ changeUserStatus(row['login_id'], "Y")}}>Enable</button> }



                

              
               
             
              </td>
            </tr>
          ))}
        </tbody>

      </table>
    </div>
  );
};

const formatNumber = (numericString) => {

  const number = parseFloat(numericString);
  if (!isNaN(number)) {
    const formatter = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    var formattedNumber = formatter.format(number);
    const withoutCommas = formattedNumber.replace(/,/g, '');
    return withoutCommas;
  }

  return numericString; // Return original string if conversion fails
};


export default UserDT;